import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InnerLoaderComponent } from './inner-loader.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';



@NgModule({
  declarations: [InnerLoaderComponent],
  exports: [
    InnerLoaderComponent
  ],
  imports: [
    CommonModule,
    MatProgressSpinnerModule
  ]
})
export class InnerLoaderModule { }
